var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"d-flex align-center button",attrs:{"to":_vm.browseLink}},[_c('span',[_vm._v(_vm._s(_vm.browseTitle))]),_vm._v(" "),_c('v-icon',{staticClass:"ml-4",attrs:{"size":_vm.$vuetify.breakpoint.mdAndUp ? 32 : 24}},[_vm._v("$vuetify.icons.Arrrow")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }